import React from 'react'

import Svg, {
  ClipPath,
  Defs,
  G,
  Path,
  RadialGradient,
  Rect,
  Stop,
} from 'react-native-svg'

const PiggyBank = ({ color = '#F2F7FF', ...props }: { color?: string }) => {
  return (
    <Svg width={48} height={48} viewBox="0 0 48 48" fill="none" {...props}>
      <G clipPath="url(#clip0_1055_2068)">
        <Rect width={48} height={48} rx={8} fill="#F2F7FF" />
        <G clipPath="url(#clip1_1055_2068)">
          <Path
            d="M9.98105 53.3058C9.44282 53.3042 8.9271 53.0942 8.54651 52.7216C8.16592 52.349 7.9514 51.8441 7.94979 51.3172L7.9498 19.4988C7.9514 18.9718 8.16593 18.4669 8.54652 18.0943C8.9271 17.7217 9.44283 17.5117 9.98106 17.5101L23.1843 17.5101L23.1843 53.3058L9.98105 53.3058Z"
            fill="url(#paint0_radial_1055_2068)"
          />
          <Path
            d="M30.2937 53.3058L26.2312 53.3058L26.2312 17.5101L30.2937 17.5101C30.8319 17.5117 31.3476 17.7217 31.7282 18.0943C32.1088 18.4669 32.3233 18.9718 32.325 19.4988L32.3249 51.3172C32.3233 51.8441 32.1088 52.349 31.7282 52.7216C31.3476 53.0942 30.8319 53.3042 30.2937 53.3058Z"
            fill="url(#paint1_radial_1055_2068)"
          />
          <Path
            d="M26.4748 52.8283L20.6249 52.8283L20.6249 51.8472L20.6249 18.4912L20.6249 17.5101L26.4749 17.5101L26.4749 18.4912L26.4748 51.8472L26.4748 52.8283Z"
            fill="url(#paint2_radial_1055_2068)"
          />
          <Path
            d="M43.0499 38.5318V42.6887C43.0491 42.9335 42.9495 43.168 42.7727 43.3411C42.5959 43.5141 42.3563 43.6117 42.1063 43.6124H35.5016C35.2515 43.6117 35.012 43.5141 34.8352 43.3411C34.6584 43.168 34.5588 42.9335 34.558 42.6887V39.9175C34.5588 39.6727 34.6584 39.4382 34.8352 39.2651C35.012 39.092 35.2515 38.9944 35.5016 38.9937L41.1628 38.9937V37.6081H42.1063C42.3563 37.6088 42.5959 37.7064 42.7727 37.8795C42.9495 38.0525 43.0491 38.2871 43.0499 38.5318ZM37.8604 41.3031C37.8604 41.1204 37.8051 40.9418 37.7014 40.7899C37.5977 40.638 37.4503 40.5196 37.2779 40.4496C37.1055 40.3797 36.9158 40.3614 36.7328 40.3971C36.5498 40.4327 36.3816 40.5207 36.2497 40.6499C36.1177 40.7791 36.0279 40.9437 35.9915 41.1229C35.955 41.302 35.9737 41.4878 36.0451 41.6566C36.1166 41.8254 36.2375 41.9696 36.3927 42.0711C36.5478 42.1726 36.7302 42.2268 36.9169 42.2268C37.1669 42.2261 37.4064 42.1285 37.5832 41.9554C37.76 41.7824 37.8597 41.5478 37.8604 41.3031Z"
            fill="white"
          />
          <Path
            d="M39.1061 24.2137L43.05 35.197L41.163 35.8575V32.9893C41.1622 32.7445 41.0626 32.51 40.8858 32.3369C40.709 32.1638 40.4694 32.0663 40.2194 32.0656H39.441L38.1106 28.3613C37.8849 28.4401 37.6454 28.4744 37.4061 28.4621C37.1667 28.4499 36.9322 28.3915 36.716 28.2902C36.4999 28.1888 36.3063 28.0467 36.1465 27.8718C35.9866 27.697 35.8637 27.4929 35.7848 27.2713L22.0469 32.0471V32.0656L18.0463 32.0656C17.9294 32.0657 17.8126 32.0564 17.6972 32.0378L17.5745 31.7053L33.6335 26.1167L39.1061 24.2137Z"
            fill="white"
          />
          <Path
            d="M15.7343 30.2043C15.8281 30.6708 16.0671 31.0976 16.4185 31.4259C16.7698 31.7542 17.2167 31.9679 17.6972 32.0378C17.8126 32.0564 17.9294 32.0657 18.0463 32.0656L40.2194 32.0656C40.4694 32.0663 40.709 32.1638 40.8858 32.3369C41.0626 32.51 41.1622 32.7445 41.163 32.9893L41.1628 38.9937L35.5016 38.9937C35.2515 38.9944 35.012 39.092 34.8352 39.2651C34.6584 39.4382 34.5588 39.6727 34.558 39.9175V42.6887C34.5588 42.9335 34.6584 43.168 34.8352 43.3411C35.012 43.5141 35.2515 43.6117 35.5016 43.6124L41.1626 43.6124V48.693C41.1626 49.2518 40.3182 50.0786 39.2756 50.0786L15.6871 50.0786C15.1866 50.0786 14.7067 49.8839 14.3528 49.5375C13.9989 49.191 13.8 48.7211 13.8 48.2311L13.8001 30.2181C13.8001 29.4831 14.0983 28.7783 14.6291 28.2586C15.16 27.7389 15.8799 27.4469 16.6307 27.4469H18.145C17.5464 27.4375 16.9653 27.645 16.5134 28.0294C16.0615 28.4139 15.7706 28.9483 15.6966 29.5299C15.6733 29.7553 15.686 29.9828 15.7343 30.2043Z"
            fill="white"
          />
          <Path
            d="M38.1106 28.3613L39.441 32.0656L22.0469 32.0656V32.0471L35.7848 27.2713C35.8637 27.4929 35.9866 27.697 36.1465 27.8718C36.3063 28.0467 36.4999 28.1888 36.716 28.2902C36.9322 28.3915 37.1667 28.4499 37.4061 28.4621C37.6454 28.4744 37.8849 28.4401 38.1106 28.3613Z"
            fill="white"
          />
          <Path
            d="M36.9169 42.2268C37.438 42.2268 37.8604 41.8132 37.8604 41.3031C37.8604 40.7929 37.4381 40.3793 36.917 40.3793C36.3959 40.3793 35.9735 40.7929 35.9735 41.303C35.9735 41.8132 36.3958 42.2268 36.9169 42.2268Z"
            fill="white"
          />
          <Path
            d="M23.5281 27.4468L32.671 24.2137L33.6146 26.0612L33.6335 26.1167L17.5745 31.7053L17.6972 32.0378C17.2167 31.9679 16.7698 31.7542 16.4185 31.4259C16.0671 31.0976 15.8281 30.6708 15.7343 30.2043L23.5281 27.4468Z"
            fill="white"
          />
          <Path
            d="M23.5281 27.4468L15.7343 30.2043C15.686 29.9828 15.6733 29.7553 15.6966 29.5299C15.7706 28.9483 16.0615 28.4139 16.5134 28.0294C16.9653 27.645 17.5464 27.4375 18.145 27.4469L23.5281 27.4468Z"
            fill="white"
          />
          <Path
            d="M43.8499 42.6887V42.6911C43.8484 43.1527 43.6604 43.5916 43.3323 43.9127C43.0049 44.2333 42.5646 44.4111 42.1087 44.4124L42.1063 44.4124L41.9626 44.4124V48.693C41.9626 49.3229 41.537 49.8741 41.1136 50.217C40.6519 50.5909 40.0069 50.8786 39.2756 50.8786L15.6871 50.8786C14.9799 50.8786 14.2983 50.6037 13.7931 50.1091M43.8499 42.6887L13.7931 50.1091C13.7931 50.1091 13.7931 50.1091 13.7931 50.1091M43.8499 42.6887L43.8499 38.5318L43.8498 38.5294C43.8484 38.0678 43.6604 37.629 43.3323 37.3078C43.0049 36.9872 42.5646 36.8094 42.1087 36.8081H42.1063H41.9628M43.8499 42.6887L41.9628 36.8081M13.7931 50.1091H13.7931C13.2874 49.614 13 48.9388 13 48.2311L13.0001 30.2181C13.0001 29.2654 13.3868 28.3553 14.0695 27.6869L14.6291 28.2586L14.0695 27.6869C14.7516 27.0191 15.6732 26.6469 16.6307 26.6469H18.0613C18.0911 26.6465 18.121 26.6465 18.1509 26.6469L23.3909 26.6468L32.4043 23.4595L33.0648 23.2259L33.3835 23.8499L34.0369 25.1294L38.8433 23.4581L39.5913 23.198L39.859 23.9434L43.803 34.9267L44.0755 35.6857L43.3143 35.9521L41.9629 36.4251L41.9628 36.8081M13.7931 50.1091L41.9628 36.8081"
            stroke="#F2F7FF"
            strokeWidth={1.6}
          />
          <Path
            d="M43.0498 38.5318L43.0498 42.6886C43.0491 42.9334 42.9494 43.1679 42.7726 43.341C42.5958 43.5141 42.3563 43.6116 42.1063 43.6124L35.5015 43.6124C35.2515 43.6116 35.0119 43.5141 34.8352 43.341C34.6584 43.1679 34.5587 42.9334 34.558 42.6886L34.558 39.9174C34.5587 39.6726 34.6584 39.4381 34.8352 39.265C35.012 39.0919 35.2515 38.9944 35.5015 38.9936L41.1627 38.9936L41.1627 37.608L42.1063 37.608C42.3563 37.6088 42.5958 37.7063 42.7726 37.8794C42.9494 38.0525 43.0491 38.287 43.0498 38.5318ZM37.8604 41.303C37.8604 41.1203 37.805 40.9417 37.7013 40.7898C37.5977 40.6379 37.4503 40.5195 37.2779 40.4496C37.1055 40.3797 36.9158 40.3614 36.7327 40.397C36.5497 40.4327 36.3816 40.5206 36.2496 40.6498C36.1177 40.779 36.0278 40.9436 35.9914 41.1228C35.955 41.302 35.9737 41.4877 36.0451 41.6565C36.1165 41.8253 36.2375 41.9696 36.3926 42.0711C36.5478 42.1726 36.7302 42.2267 36.9168 42.2267C37.1668 42.226 37.4064 42.1285 37.5832 41.9554C37.76 41.7823 37.8596 41.5478 37.8604 41.303Z"
            fill="url(#paint3_radial_1055_2068)"
          />
          <Path
            d="M39.1061 24.2136L43.0501 35.1969L41.163 35.8574L41.163 32.9892C41.1623 32.7444 41.0626 32.5099 40.8858 32.3368C40.709 32.1637 40.4695 32.0662 40.2195 32.0654L39.4411 32.0654L38.1107 28.3612C37.8849 28.44 37.6455 28.4742 37.4061 28.462C37.1668 28.4498 36.9323 28.3914 36.7161 28.29C36.4999 28.1887 36.3063 28.0466 36.1465 27.8717C35.9867 27.6968 35.8638 27.4928 35.7849 27.2712L22.047 32.047L22.047 32.0654L18.0464 32.0654C17.9294 32.0656 17.8126 32.0563 17.6972 32.0377L17.5746 31.7052L33.6336 26.1165L39.1061 24.2136Z"
            fill="url(#paint4_radial_1055_2068)"
          />
          <Path
            d="M15.7343 30.2042C15.8281 30.6708 16.0671 31.0975 16.4185 31.4258C16.7698 31.7541 17.2164 31.9679 17.6969 32.0378C17.8123 32.0564 17.929 32.0657 18.046 32.0656L40.2191 32.0656C40.4691 32.0663 40.7087 32.1638 40.8854 32.3369C41.0622 32.51 41.1619 32.7445 41.1626 32.9893L41.1626 38.9936L35.5014 38.9936C35.2514 38.9944 35.0118 39.0919 34.835 39.265C34.6583 39.4381 34.5586 39.6726 34.5579 39.9174L34.5579 42.6886C34.5586 42.9334 34.6583 43.1679 34.835 43.341C35.0118 43.514 35.2514 43.6116 35.5014 43.6123L41.1626 43.6123L41.1626 48.6929C41.1626 49.2518 40.3182 50.0785 39.2756 50.0785L15.6871 50.0785C15.1866 50.0785 14.7067 49.8839 14.3528 49.5374C13.9989 49.1909 13.8 48.721 13.8 48.231L13.8 30.2181C13.8 29.4831 14.0983 28.7782 14.6291 28.2585C15.16 27.7388 15.8799 27.4468 16.6307 27.4468L18.145 27.4468C17.5464 27.4374 16.9653 27.6449 16.5134 28.0294C16.0615 28.4138 15.7706 28.9482 15.6966 29.5299C15.6733 29.7552 15.686 29.9827 15.7343 30.2042Z"
            fill="url(#paint5_radial_1055_2068)"
          />
          <Path
            d="M38.1106 28.3614L39.441 32.0656L22.0469 32.0656L22.0469 32.0471L35.7848 27.2714C35.8637 27.4929 35.9866 27.697 36.1464 27.8718C36.3063 28.0467 36.4998 28.1889 36.716 28.2902C36.9322 28.3915 37.1667 28.45 37.406 28.4622C37.6454 28.4744 37.8848 28.4401 38.1106 28.3614Z"
            fill="url(#paint6_radial_1055_2068)"
          />
          <Path
            d="M36.917 42.2266C37.4381 42.2266 37.8606 41.8131 37.8606 41.3029C37.8606 40.7927 37.4381 40.3792 36.917 40.3792C36.3959 40.3792 35.9735 40.7927 35.9735 41.3029C35.9735 41.8131 36.3959 42.2266 36.917 42.2266Z"
            fill="white"
          />
          <Path
            d="M23.5281 27.4467L32.671 24.2136L33.6145 26.0611L33.6334 26.1165L17.5744 31.7052L17.6971 32.0377C17.2166 31.9678 16.77 31.754 16.4186 31.4257C16.0673 31.0974 15.8283 30.6707 15.7345 30.2041L23.5281 27.4467Z"
            fill="url(#paint7_radial_1055_2068)"
          />
          <Path
            d="M23.5282 27.4468L15.7346 30.2042C15.6863 29.9827 15.6736 29.7552 15.6969 29.5299C15.7709 28.9482 16.0618 28.4138 16.5137 28.0294C16.9656 27.6449 17.5467 27.4374 18.1453 27.4468L23.5282 27.4468Z"
            fill="#3982DD"
          />
        </G>
      </G>
      <Defs>
        <RadialGradient
          id="paint0_radial_1055_2068"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(23.55 20.3738) rotate(112.536) scale(33.0708 29.5439)"
        >
          <Stop stopColor="#E0ECFF" />
          <Stop offset={1} stopColor="#92BBFF" />
        </RadialGradient>
        <RadialGradient
          id="paint1_radial_1055_2068"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(23.55 20.3738) rotate(112.536) scale(33.0708 29.5439)"
        >
          <Stop stopColor="#E0ECFF" />
          <Stop offset={1} stopColor="#92BBFF" />
        </RadialGradient>
        <RadialGradient
          id="paint2_radial_1055_2068"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(23.5499 34.2147) rotate(-90) scale(16.7045 21.04)"
        >
          <Stop stopColor="#9DC2FF" />
          <Stop offset={1} stopColor="#3D7FEB" />
        </RadialGradient>
        <RadialGradient
          id="paint3_radial_1055_2068"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(40.8559 38.2386) rotate(145.743) scale(5.4693 16.8573)"
        >
          <Stop stopColor="#FFCE8E" />
          <Stop offset={1} stopColor="#D3A569" />
        </RadialGradient>
        <RadialGradient
          id="paint4_radial_1055_2068"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(32.8609 23.1051) rotate(138.523) scale(20.4371 61.3669)"
        >
          <Stop stopColor="#FFEACE" />
          <Stop offset={1} stopColor="#E9C290" />
        </RadialGradient>
        <RadialGradient
          id="paint5_radial_1055_2068"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(34.0551 33.2339) rotate(135.607) scale(21.472 20.5013)"
        >
          <Stop stopColor="#9DC2FF" />
          <Stop offset={1} stopColor="#3D7FEB" />
        </RadialGradient>
        <RadialGradient
          id="paint6_radial_1055_2068"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(34.9472 27.7749) rotate(165.132) scale(9.5802 15.7398)"
        >
          <Stop stopColor="#FFCE8E" />
          <Stop offset={1} stopColor="#D3A569" />
        </RadialGradient>
        <RadialGradient
          id="paint7_radial_1055_2068"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(29.0092 25.0353) rotate(157.167) scale(10.3383 24.4943)"
        >
          <Stop stopColor="#FFCE8E" />
          <Stop offset={1} stopColor="#D3A569" />
        </RadialGradient>
        <ClipPath id="clip0_1055_2068">
          <Rect width={48} height={48} rx={8} fill="white" />
        </ClipPath>
        <ClipPath id="clip1_1055_2068">
          <Rect
            width={39}
            height={42}
            fill="white"
            transform="translate(6 11)"
          />
        </ClipPath>
      </Defs>
    </Svg>
  )
}

export default PiggyBank
